import { createContext } from 'react';

/** Context of the import wizard; read it with `useImportWizard`. */
export const ImportWizardContext = createContext(null);
